import { useEffect, useState } from "react";
import { activeMonth } from "./activeMonth";
import {
  founderMonthOrFallback,
  loadFounderMonthFromSupabase,
} from "./monthAdapter";
import type { FounderMonth } from "./types";

/** Static month first. A usable database month replaces it; failures do not. */
export function useFounderMonth(): FounderMonth {
  const [month, setMonth] = useState<FounderMonth>(activeMonth);

  useEffect(() => {
    let cancelled = false;
    void loadFounderMonthFromSupabase().then((loaded) => {
      if (cancelled) return;
      const next = founderMonthOrFallback(loaded);
      if (next !== activeMonth) setMonth(next);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return month;
}
